import { FF_ENABLE_CONCESSION_AWARENESS_CHECKOUT } from '@/constants/featureFlags';
import useFeatureFlags from '@/hooks/useFeatureFlags';
import { Box, Typography } from '@montugroup/design-system';
import { DEFAULT_CONCESSION_DISCOUNT_TEXT } from './constants';
import { LineItem } from './LineItem';
import { DiscountText, LineItemRoot, SectionDivider } from './Styles';
import type { Discount } from './types';

interface ProductLineItemProps {
  quantity: number;
  supplier: string;
  label: string;
  amount: string;
  isConcession: boolean;
  discount?: Discount;
}

export function ProductLineItem(props: ProductLineItemProps) {
  const { flags } = useFeatureFlags();
  const { label, amount, quantity, supplier, isConcession, discount } = props;

  return (
    <Box>
      <LineItemRoot>
        <Box>
          <Typography variant="body2">{label}</Typography>
          <Typography variant="body2">{supplier}</Typography>
          <Typography variant="body2">
            Units:{' '}
            <Typography component="span" variant="inherit">
              {quantity}
            </Typography>
          </Typography>
        </Box>
        <Typography
          variant="body2"
          component={discount ? 's' : 'p'}
          sx={(theme) => ({
            fontWeight: discount ? 400 : 600,
            color: discount ? theme.palette.text.disabled : theme.palette.text.primary,
            marginLeft: theme.spacing(4),
          })}
        >
          {amount}
        </Typography>
      </LineItemRoot>
      {discount && (
        <Box sx={{ marginTop: 2 }}>
          <LineItem label={discount.display} amount={discount.formattedAmount} isDiscount />
        </Box>
      )}
      {flags[FF_ENABLE_CONCESSION_AWARENESS_CHECKOUT] && isConcession && (
        <DiscountText variant="body2">{DEFAULT_CONCESSION_DISCOUNT_TEXT}</DiscountText>
      )}
      <SectionDivider />
    </Box>
  );
}
